
// http://www.quirksmode.org/js/findpos.html
function getPos(obj) {

    let curleft = 0,
        curtop = 0;

    if (obj.offsetParent)
    do {
        curleft += obj.offsetLeft;
        curtop += obj.offsetTop;

    } while (obj = obj.offsetParent);

    return [curleft,curtop];
}

function getBounds(elmt, anchor) {

    let doc  = document,
        win  = window,
        body = doc.body,

        // pageXOffset and pageYOffset work everywhere except IE <9.
        offsetX = win.pageXOffset !== undefined ? win.pageXOffset :
            (doc.documentElement || body.parentNode || body).scrollLeft,
        offsetY = win.pageYOffset !== undefined ? win.pageYOffset :
            (doc.documentElement || body.parentNode || body).scrollTop,

        rect = elmt.getBoundingClientRect();

    if (anchor === void 0) {
        anchor = body;
    }

    if (elmt !== anchor) {
        let parent = elmt.parentNode;

        // The element's rect will be affected by the scroll positions of
        // all of its scrollable parents, not just the window, so we have
        // to walk up the tree and collect every scroll offset. Good times.
        while (parent !== anchor) {
            offsetX += parent.scrollLeft;
            offsetY += parent.scrollTop;
            parent   = parent.parentNode;
        }
    }

    // iOS hack
    return {
        x: rect.left + offsetX,
        y: rect.top + offsetY,
        w: rect.width,
        h: rect.height,
        r: rect.right + offsetX,
        b: rect.bottom + offsetY
        /*bottom: rect.bottom + offsetY,
        height: rect.height,
        left  : rect.left + offsetX,
        right : rect.right + offsetX,
        top   : rect.top + offsetY,
        width : rect.width*/
    };
}

export {getBounds}